import { Counter } from "api/types/sketch";
import { Dispatch } from "redux";
import { Action } from "api/action_types/sketch";
import { ActionType } from "api/action_types/sketch";

export const createLocalCounter = (counter: Counter) => {
    return (dispatch: Dispatch<Action>) => {
        dispatch({
            type: ActionType.CREATE_LOCAL_COUNTER,
            payload: counter
        });
    }
}